module.exports = ".fa-info-circle {\r\n  color: #62B1F6;\r\n  /*color: var(--info-blue);*/\r\n}\r\n\r\n#main-lookup-div {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n#form-div {\r\n  \r\n}\r\n\r\n#form-heading {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.required\r\n{\r\n    color: red;\r\n}\r\n\r\nbutton:disabled, button.close:disabled {\r\n  opacity: 0.4;\r\n  background: gray;\r\n  cursor: default;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/class-history-lookup/class-history-lookup.component.css
// module id = ./src/app/class-history-lookup/class-history-lookup.component.css
// module chunks = main